import Fetch from '@/hooks/fetch';
import { pagingHookConfig } from '@/hooks/paging';
import actions from '../constants';

export default {
  useFetchAudits: ({ category, code }, readStatus, config = pagingHookConfig()) => Fetch.useFetchDispatch(
    actions.FETCH_AUDITS,
    readStatus,
    { category, code },
    config,
  ),
};
